import Calendar from "@/utils/calendar";

export const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      width: 40,
      customRender: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "图片",
      dataIndex: "productImg",
      key: "productImg",
      scopedSlots: {
        customRender: "image",
      },
    },
    {
      title: "商品SKU",
      dataIndex: "shopProductSku",
      key: "shopProductSku",
    },
    {
      title: "丢件数量",
      dataIndex: "abnormalAmount",
      key: "abnormalAmount",
      customRender: (text, record, index) => {
        return record.abnormalAmount - record.backAmount;
      },
    },
    {
      title: "物流单号",
      dataIndex: "expressNo",
      key: "expressNo",
    },
    {
      title: "操作",
      dataIndex: "idAction",
      width: 270,
      key: "idAction",
      fixed: "right",
      scopedSlots: {
        customRender: "action",
      },
    },
  ];